export const BOARD_MEETING_STATUS = {
    DRAFT: "draft",
    PUBLISHED: "published",
    IN_PROGRESS: "in_progress",
    COMPLETED: "completed",
    ARCHIVED: "archived",
};
export const BOARD_ASSET_STATUS = {
    DRAFT: "draft",
    FINAL: "final",
    SUPERSEDED: "superseded",
};
/**
 * Valid status transitions for board meetings.
 * Key = current status, Value = array of allowed next statuses.
 */
export const BOARD_ALLOWED_TRANSITIONS = {
    draft: ["published"],
    published: ["in_progress", "draft"],
    in_progress: ["completed"],
    completed: ["archived"],
    archived: [],
};
export function canTransition(from, to) {
    const allowed = BOARD_ALLOWED_TRANSITIONS[from];
    return allowed.includes(to);
}
//# sourceMappingURL=board-states.js.map